export default __webpack_public_path__ + "static/media/funds__fundraising-library.2c435949.png";